(function () {
  const { Fade, ClassNames } = window.ThemeCarousel.plugins;
  const sliderRegistry = new WeakMap();
  const resizeObservers = new WeakMap();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getMargin = (width) => (width < 991 ? 40 : 110);

  const getLoopDistance = (index, selected, count) => {
    let diff = index - selected;
    if (diff > count / 2) diff -= count;
    if (diff < -count / 2) diff += count;
    return diff;
  };

  const updateCardStack = (textEmbla, cardRoot, margin) => {
    const slides = cardRoot.querySelectorAll('.testimonials__cards-slide');
    const selected = textEmbla.selectedScrollSnap();
    const count = slides.length;

    slides.forEach((slide, index) => {
      slide.classList.toggle('is-selected', index === selected);

      if (reduceMotion) {
        slide.style.transform = '';
        slide.style.opacity = '';
        slide.style.zIndex = '';
        return;
      }

      const diff = getLoopDistance(index, selected, count);

      if (diff === 0) {
        slide.style.transform = 'translateX(0) scale(1)';
        slide.style.opacity = '1';
        slide.style.zIndex = '3';
      } else if (diff === -1) {
        slide.style.transform = `translateX(${-margin * 0.5}px) scale(0.97)`;
        slide.style.opacity = '0.4';
        slide.style.zIndex = '1';
      } else if (diff === 1) {
        slide.style.transform = `translateX(${margin}px) scale(0.94)`;
        slide.style.opacity = '1';
        slide.style.zIndex = '2';
      } else if (diff === 2) {
        slide.style.transform = `translateX(${margin * 2}px) scale(0.88)`;
        slide.style.opacity = '1';
        slide.style.zIndex = '1';
      } else {
        slide.style.transform = `translateX(${margin}px) scale(0.94)`;
        slide.style.opacity = '0';
        slide.style.zIndex = '0';
      }
    });
  };

  const wireCardStack = (textEmbla, cardRoot, margin) => {
    const update = () => updateCardStack(textEmbla, cardRoot, margin);

    textEmbla.on('select', update);
    textEmbla.on('reInit', update);
    update();

    return () => {
      textEmbla.off('select', update);
      textEmbla.off('reInit', update);
    };
  };

  const destroySliders = (section) => {
    const instances = sliderRegistry.get(section);
    if (!instances) return;

    instances.cleanup?.();
    if (instances.textViewport) {
      window.ThemeCarousel.destroy(instances.textViewport);
    }

    sliderRegistry.delete(section);
  };

  const initSection = (section, isUpdate) => {
    const textViewport = section.querySelector('.testimonials__text-viewport');
    const cardRoot = section.querySelector('.testimonials__cards');

    if (!textViewport || !cardRoot || !section.querySelector('.testimonials__controls')) {
      return;
    }

    const margin = getMargin(section.getBoundingClientRect().width);
    const existing = sliderRegistry.get(section);

    if (existing && existing.bucket === margin) {
      return;
    }

    destroySliders(section);

    const duration = reduceMotion ? 0 : 15;
    const prevArrow = section.querySelector('.testimonials__button--prev');
    const nextArrow = section.querySelector('.testimonials__button--next');

    const textPlugins = reduceMotion
      ? [ClassNames({ selected: 'is-selected' })]
      : [Fade(), ClassNames({ selected: 'is-selected' })];

    let cardStackCleanup = null;

    const textEmbla = window.ThemeCarousel.create(
      textViewport,
      {
        loop: true,
        containScroll: false,
        duration,
      },
      textPlugins,
      {
        prev: prevArrow,
        next: nextArrow,
        fraction: '.testimonials__navigation',
        onInit: (emblaApi) => {
          section.querySelector('.testimonials__slider')?.classList.add('is-initialized');
          cardRoot.classList.add('is-initialized');
          cardStackCleanup = wireCardStack(emblaApi, cardRoot, margin);
        },
        onDestroy: () => {
          cardStackCleanup?.();
          cardStackCleanup = null;
        },
      },
    );

    if (textEmbla) {
      sliderRegistry.set(section, {
        textViewport,
        bucket: margin,
        cleanup: () => {
          cardStackCleanup?.();
          cardStackCleanup = null;
        },
      });
    }

    if (isUpdate && textEmbla) {
      textEmbla.reInit();
    }
  };

  const observeSection = (section) => {
    if (resizeObservers.has(section)) return;

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        initSection(entry.target, true);
      });
    });

    resizeObserver.observe(section);
    resizeObservers.set(section, resizeObserver);
  };

  const initTestimonials = (root) => {
    const sections =
      root instanceof Element && root.classList.contains('testimonials-section')
        ? [root]
        : Array.from(root.querySelectorAll?.('.testimonials-section') || []);

    sections.forEach((section) => {
      initSection(section, false);
      observeSection(section);
    });
  };

  initTestimonials(document);

  document.addEventListener('shopify:section:load', (event) => {
    initTestimonials(event.target);
  });
})();
